<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable 
      max-width="800px"
      transition="dialog-transition"
    >
      <v-card style="border-radius: 12px;" v-if="!loading_categories">
        <v-card-title primary-title>
          Categoria para {{item.name}}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-radio-group v-model="selected_cat">
            <v-radio v-for="(cat, cat_idx) in all_categories" :color="cat.kind == 'I'? 'error' : 'success'" class="mb-3" :key="cat.id" :value="cat.id">
              <template v-slot:label>
                <span :class="[cat.kind == 'I'? 'error--text' : 'success--text']">{{cat.code}}- {{cat.name}}</span>
              </template>
            </v-radio>
          </v-radio-group>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations} from 'vuex'

export default {
  name: 'DialogSelectCategoryForEmployee',
  props: {
    item: {
      type: Object,
    },
    item_idx: {
      type: Number,
    },
    base_value: {
      type: Number,
    },
  },
  data() {
    return {
      dialog: true,
      selected_cat: null,
      loading_categories: false 
    }
  },
  mounted () {
    this.getCategories();
  },
  methods: {
    getCategories() {
      this.loading_categories = true;
      this.indexCategories().then(() => {
        this.loading_categories = false;
      })
    },
    ...mapActions({
      indexCategories: 'Category/getLocalCategories'
    })
  },
  computed: {
    ...mapState({
      all_categories: state => state.Category.all_categories,
      current_execution: state => state.Execution.current_execution,
      current_time: state => state.Execution.current_time,
      current_time_idx: state => state.Execution.current_time_idx,
      profile: state => state.User.profile,
      // data: state=> state.Module.state_var
    }),
  },
  mounted () {
    this.selected_cat = this.base_value;
  },
  watch: {
    selected_cat(nv, ov) {
      console.log(nv)
      if (this.base_value != nv){
        setTimeout(() => {
          this.$emit('selectedCat', nv)
        }, 500);
      }
    },
    dialog (nv, ov) {
      if (nv == false){
        this.$emit('close')
      }
    }
  },
  
}
</script>

<style lang="scss" scoped>

</style>